<template>
  <div class="NewsDetails">
    <banner title="新闻详情" subtitle="NEWS DETAILS" />
    <div class="NewsDetails-product" v-loading="loading">
      <div class="NewsDetails-product-content">
        <img v-if="newsIdList.Img" v-lazy="$img(newsIdList.Img)" alt />
        <p class="product-title">{{newsIdList.Title}}</p>
        <p class="product-time">{{formatDate(newsIdList.CreateTime)}}</p>
        <p class="product-content">{{newsIdList.Content}}</p>
        <router-link class="back-link" to="/news">← 返回资讯列表</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  name: "NewsDetails",
  components: {
    Banner
  },
  data() {
    return {
      loading: true,
      pid: 0,
      newsIdList: {}
    };
  },
  created() {
    this.pid = this.$route.params.id;
  },
  mounted() {
    this.loadData();
  },
  methods: {
    formatDate(value) {
      if (!value) return "";
      const t = new Date(value);
      if (Number.isNaN(t.getTime())) return value;
      const m = `${t.getMonth() + 1}`.padStart(2, "0");
      const d = `${t.getDate()}`.padStart(2, "0");
      return `${t.getFullYear()}-${m}-${d}`;
    },
    loadData() {
      this.loading = true;
      this.$http
        .get(`News/${this.pid}`)
        .then(response => {
          this.newsIdList = response.data || {};
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.NewsDetails {
  width: 100%;
  background: linear-gradient(180deg, #14679f 0%, #0f4f7d 100%);
  padding-bottom: 40px;

  &-product {
    width: 1240px;
    max-width: calc(100% - 32px);
    margin: -28px auto 0;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 -8px 30px rgba(8, 28, 46, 0.12);
    position: relative;
    z-index: 1;

    &-content {
      width: 760px;
      max-width: calc(100% - 48px);
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 48px 0 56px;

      img {
        width: 100%;
        border-radius: 12px;
        object-fit: cover;
        max-height: 420px;
        box-shadow: 0 10px 24px rgba(15, 47, 74, 0.1);
      }

      .product-title {
        margin: 0;
        font-size: 28px;
        color: #17324a;
        padding: 24px 0 8px;
        font-weight: 600;
        line-height: 1.4;
      }

      .product-time {
        margin: 0;
        color: #7a93a8;
        font-size: 13px;
      }

      .product-content {
        margin: 0;
        font-size: 16px;
        font-weight: 400;
        color: #3d5568;
        line-height: 1.9;
        padding: 22px 0 28px;
        white-space: pre-wrap;
      }

      .back-link {
        color: #1f6fab;
        text-decoration: none;
        font-size: 14px;
      }
    }
  }
}

@media (max-width: 720px) {
  .NewsDetails-product-content {
    padding: 28px 0 36px;
  }

  .NewsDetails-product-content .product-title {
    font-size: 22px;
  }

  .NewsDetails-product-content img {
    max-height: 240px;
  }
}
</style>
